/* eslint-disable */
import {
  CREATE_FUND,
  GET_ALL_FUNDS,
  GET_FUND,
  GET_PART,
  UPDATE_FUND,
  GET_ALL_ISSUER_SIGNERS,
  GET_ALL_PRODUCT_SIGNERS,
  ADD_ISSUER_SIGNER,
  ADD_PRODUCT_SIGNER,
  CREATE_PERSON,
  UPDATE_PERSON,
  UPDATE_ISSUER_SIGNER,
  UPDATE_PRODUCT_SIGNER,
  ADD_FUND_PART,
  UPDATE_FUND_PART,
  GET_BS_TEMPLATES,
  ADD_BS_TEMPLATES,
  GET_TEMPLATE_BY_NAME,
  GET_NET_ASSET_VALUE,
  GET_COLORS,
  GET_ENGAGEMENT_LETTER_TEMPLATES,
  GET_ENGAGEMENT_LETTER_BY_NAME,
  GET_MIFID_LETTER_TEMPLATES,
  GET_MIFID_LETTER_BY_NAME,
  GET_CONVENTION_LETTER_TEMPLATES,
  GET_CONVENTION_LETTER_BY_NAME,
  GET_INITIAL_CONTACT_CONTRACT_TEMPLATES,
  GET_INITIAL_CONTACT_CONTRACT_BY_NAME,
  GET_ALL_FUNDS_IN_TEAM,
  GET_NET_ASSET_PART_VALUE, GET_TRANSLATION_BY_KEY, GET_TRANSFER_TEMPLATES, GET_LSFIN_LETTER_BY_NAME, GET_FCA_LETTER_BY_NAME, GET_SEC_LETTER_BY_NAME, GET_SEC_LETTER_TEMPLATES, GET_FCA_LETTER_TEMPLATES, GET_LSFIN_LETTER_TEMPLATES,
} from "../actionTypes";

const initialStateFunds: FundsState = {
  fund: "",
  funds_list: "",
  funds_in_team: [],
  signer: {},
  part: {},
};

export const FundsReducer = (
  state: FundsState = initialStateFunds,
  action: FundsActions
) => {
  switch (action.type) {
    case GET_ALL_FUNDS:
      return {
        ...state,
        funds_list: action.payload,
      };
    case CREATE_FUND:
      return {
        ...state,
        fund: action.payload,
      };
    case GET_FUND:
      return {
        ...state,
        fund: action.payload,
      };
    case UPDATE_FUND:
      return {
        ...state,
        fund: action.payload,
      };
    case GET_ALL_ISSUER_SIGNERS:
      return {
        ...state,
        issuer_fund_signers_list: action.payload,
      };
    case GET_ALL_PRODUCT_SIGNERS:
      return {
        ...state,
        product_fund_signers_list: action.payload,
      };
    case ADD_ISSUER_SIGNER:
      return {
        ...state,
        signer: action.payload,
      };
    case ADD_PRODUCT_SIGNER:
      return {
        ...state,
        signer: action.payload,
      };
    case CREATE_PERSON:
      return {
        ...state,
        person: action.payload,
        product_fund_signers_list: action.signer,
        issuer_fund_signers_list: action.signer,
      };
    case UPDATE_PERSON:
      return {
        ...state,
      };
    case UPDATE_ISSUER_SIGNER:
      return {
        ...state,
      };
    case UPDATE_PRODUCT_SIGNER:
      return {
        ...state,
      };
    case ADD_FUND_PART:
    case GET_PART:
      return {
        ...state,
        part: action.payload,
      };
    case UPDATE_FUND_PART:
      return {
        ...state,
        part: action.payload,
      };
    case GET_BS_TEMPLATES:
      return {
        ...state,
        bs_templates: action.payload,
      };
    case GET_TRANSFER_TEMPLATES:
      return {
        ...state,
        transfer_templates: action.payload,
      };
    case ADD_BS_TEMPLATES:
      return {
        ...state,
      };
    case GET_TEMPLATE_BY_NAME:
      return {
        ...state,
        template_by_name: action.payload,
      };
    case GET_NET_ASSET_VALUE:
      return {
        ...state,
        net_asset_value_list: action.payload,
      };
    case GET_NET_ASSET_PART_VALUE:
      return {
        ...state,
        net_asset_value_part_list: action.payload,
      };
    case GET_COLORS:
      return {
        ...state,
        colors: action.payload,
      };
    case GET_ENGAGEMENT_LETTER_TEMPLATES:
      return {
        ...state,
        engagement_letter_list: action.payload,
      };
    case GET_ENGAGEMENT_LETTER_BY_NAME:
      return {
        ...state,
        engagement_letter: action.payload,
      };
    case GET_MIFID_LETTER_TEMPLATES:
      return {
        ...state,
        mifid_letter_list: action.payload,
      };
    case GET_SEC_LETTER_TEMPLATES:
      return {
        ...state,
        sec_letter_list: action.payload,
      };
    case GET_FCA_LETTER_TEMPLATES:
      return {
        ...state,
        fca_letter_list: action.payload,
      };
    case GET_LSFIN_LETTER_TEMPLATES:
      return {
        ...state,
        lsfin_letter_list: action.payload,
      };
    case GET_MIFID_LETTER_BY_NAME:
      return {
        ...state,
        mifid_letter: action.payload,
      };
    case GET_SEC_LETTER_BY_NAME:
      return {
        ...state,
        sec_letter: action.payload,
      };
    case GET_FCA_LETTER_BY_NAME:
      return {
        ...state,
        fca_letter: action.payload,
      };
    case GET_LSFIN_LETTER_BY_NAME:
      return {
        ...state,
        lsfin_letter: action.payload,
      };
    case GET_CONVENTION_LETTER_TEMPLATES:
      return {
        ...state,
        convention_letter_list: action.payload,
      };
    case GET_CONVENTION_LETTER_BY_NAME:
      return {
        ...state,
        convention_letter: action.payload,
      };
    case GET_INITIAL_CONTACT_CONTRACT_TEMPLATES:
      return {
        ...state,
        initial_contact_contract_list: action.payload,
      };
    case GET_INITIAL_CONTACT_CONTRACT_BY_NAME:
      return {
        ...state,
        initial_contact_contract: action.payload,
      };
    case GET_TRANSLATION_BY_KEY:
      return {
        ...state,
        translation: action.payload,
      };
    case GET_ALL_FUNDS_IN_TEAM:
      return {
        ...state,
        funds_in_team: action.payload,
      }
    default:
      return {
        ...state,
      };
  }
};
